// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".qd5ZT{display:-webkit-box;overflow:hidden;white-space:normal;-webkit-line-clamp:var(--lineClampNumber);-webkit-box-orient:vertical}.qd5ZT._21IPH{white-space:pre-line;-webkit-line-clamp:unset}", ""]);
// Exports
exports.locals = {
	"NAVBAR_HEIGHT": "72",
	"TABLET_WIDTH": "768",
	"DESKTOP_WIDTH": "1024",
	"WIDE_DESKTOP_WIDTH": "1440",
	"wrapper": "qd5ZT",
	"expanded": "_21IPH"
};
module.exports = exports;
